import axios from 'axios';
import Config from '../../utils/config/config';
import { getSessinIdFromLS, isUserOnline } from '../storage/LocalStorage';

const baseUrl = Config.wpsGatewayRestApiKey
const xApiKey = Config.xApiKey
let connectionId = getSessinIdFromLS();

export const setSessionIdInAxios = (newConnectionId) => {
  connectionId = newConnectionId;
  axiosInstance.defaults.headers['X-Previous-Connection-Id'] = connectionId;
};

const axiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    "x-api-key": xApiKey,
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const connectionId = localStorage.getItem("connectionId");
    console.log('axiosInstance connectionId',connectionId)
    if (connectionId) {
      console.log(`%c Added connectionId to api request ${connectionId}`, "color:green");
      config.headers['X-Previous-Connection-Id'] = connectionId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        localStorage.removeItem('connectionId');
        window.location.href = '/login';
       }
      if(status === 500){
       return error.response
      }
    }
    return Promise.reject(error);
  }
);

const checkOnline = () => {
  if (!isUserOnline()) {
    const err = new Error("User is offline");
    console.error(err.message);
    return Promise.reject(err);
  }
  return Promise.resolve();
};


const Api = {
  get: (config = {}) =>
    checkOnline().then(() => axiosInstance.get("/", config)),

  post: (data, config = {}) =>
    checkOnline().then(() => axiosInstance.post("/", data, config)),

  put: (data, config = {}) =>
    checkOnline().then(() => axiosInstance.put("/", data, config)),

  patch: (data, config = {}) =>
    checkOnline().then(() => axiosInstance.patch("/", data, config)),
};


export default Api;
